// Select all video cards
const videoCards = document.querySelectorAll(".video-card");
const closeButtons = document.querySelectorAll(".modal-close");

function getEmbedUrl(provider, videoId) {
    if (provider === "youtube") {
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }

    if (provider === "vimeo") {
        return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }

    return "";
}

videoCards.forEach(card => {
    card.addEventListener("click", function () {
        const videoId = card.getAttribute("data-video-id");
        const provider = card.getAttribute("data-video-provider");
        const modal = document.querySelector(`#modal-${videoId}`); // Find the corresponding modal

        if (!modal) return;

        const iframe = modal.querySelector("iframe");
        const embedUrl = getEmbedUrl(provider, videoId);

        if (iframe && embedUrl) {
            iframe.src = embedUrl; // Load the video with autoplay
        }

        modal.classList.add("active"); // Show the modal
    });
});

// Close modal logic
closeButtons.forEach(button => {
    button.addEventListener("click", function () {
        const modal = button.closest(".video-resource-modal");
        if (modal) {
            const iframe = modal.querySelector("iframe");
            if (iframe) {
                iframe.src = ""; // Stop the video by resetting the iframe src
            }
            modal.classList.remove("active"); // Hide the modal
        }
    });
});
